import React, { useState, useEffect } from "react";
import logoBlue from "../components/images/logoblue.png";
import "./userSubscriptionDetails.css";
import { getUserSubscriptionDetails } from "../services/user.services";
import { ArrowBack, Delete, Visibility, Add } from "@material-ui/icons";
import { Link, useHistory, useParams } from "react-router-dom";

const UserSubscriptionDetails = (props) => {
  let history = useHistory();

  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { subId } = useParams();
  console.log("<< SUBSCRIPTION DATA >>", subscriptionData);

  useEffect(() => {
    const fnt = async () => {
      try {
        setLoading(true);
        const response = await getUserSubscriptionDetails(
          subId,
          JSON.parse(sessionStorage.getItem("myData"))
        );
        setSubscriptionData(response.data);
      } catch (err) {
        console.log(
          "errorrrrrr in getUserSubscriptionDetails",
          err?.response?.data?.message
        );
      } finally {
        setLoading(false);
      }
    };
    fnt();
  }, []);

  return (
    <div className="user">
      <div className="userHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userTitle">Subscription Details</h1>
        </div>
        <img className="userLogo" src={logoBlue} alt="logo" width="150px"></img>
      </div>

      <div className="subName">
        {subscriptionData?.subscriptionType.subscriptionName ===
        "Free trial(Clock stats)"
          ? "Free Trial"
          : subscriptionData?.subscriptionType.subscriptionName ===
            "Free trial(Clock only)"
          ? "Free Trial"
          : subscriptionData?.subscriptionType.subscriptionName ===
            "times allowed(stats)"
          ? "Usage Times"
          : subscriptionData?.subscriptionType.subscriptionName ===
            "times allowed(only)"
          ? "Usage Times"
          : subscriptionData?.subscriptionType.subscriptionName}
      </div>

      <div className="subDetailsView">
        <div className="subDetailsViewR1">
          <div className="subDetailsClockType">
            <span>Clock type: </span>
            {subscriptionData?.subscriptionType.type}
          </div>
          <div className="subDetailsClockType">
            <span>Cost: </span>
            {subscriptionData?.subscriptionType.subscriptionName ===
            "Free trial(Clock stats)"
              ? "Free"
              : subscriptionData?.subscriptionType.subscriptionName ===
                "Free trial(Clock only)"
              ? "Free"
              : subscriptionData?.subscriptionType.subscriptionName ===
                "times allowed(stats)"
              ? "$" +
                subscriptionData?.subscriptionType.cost *
                  subscriptionData?.timesAllowed
              : subscriptionData?.subscriptionType.subscriptionName ===
                "times allowed(only)"
              ? "$" +
                subscriptionData?.subscriptionType.cost *
                  subscriptionData?.timesAllowed
              : "$" + subscriptionData?.subscriptionType.cost}
          </div>
        </div>
        <div className="subDetailsViewR2">
          {subscriptionData?.subscriptionType.durationDays === 0 ? (
            <div className="subDetailsUsage">
              <span>Usage: </span>{" "}
              {subscriptionData?.subscriptionType.subscriptionName ===
              "Free trial(Clock stats)"
                ? "1x time"
                : subscriptionData?.subscriptionType.subscriptionName ===
                  "Free trial(Clock only)"
                ? "1x time"
                : subscriptionData?.timesAllowed + "x times"}
            </div>
          ) : (
            <div className="subDetailsUsage">
              <span>Duration: </span>{" "}
              {subscriptionData?.subscriptionType.durationDays} days
            </div>
          )}
          <div className="subDetailsValidity">
            <span>Validity:</span>{" "}
            {subscriptionData?.subscriptionType.subscriptionName ===
              "Free trial(Clock only)" ||
            subscriptionData?.subscriptionType.subscriptionName ===
              "Free trial(Clock stats)" ? (
              Number(subscriptionData?.timesUsed) === 0 ? (
                <span className="activeTxt">active</span>
              ) : (
                <span className="expiredTxt"> Expired </span>
              )
            ) : subscriptionData?.subscriptionType.subscriptionName ===
                "times allowed(stats)" ||
              subscriptionData?.subscriptionType.subscriptionName ===
                "times allowed(only)" ? (
              Number(subscriptionData?.timesUsed) ===
              Number(subscriptionData?.timesAllowed) ? (
                <span className="expiredTxt"> Expired </span>
              ) : (
                <span className="activeTxt">active</span>
              )
            ) : Number(subscriptionData?.endTime) - Date.now() > 0 ? (
              <text>
                {(
                  (Number(subscriptionData?.endTime) - Date.now()) /
                  86400000
                ).toFixed(1)}{" "}
                days left
              </text>
            ) : (
              <span className="expiredTxt"> Expired </span>
            )}
          </div>
        </div>
        <div className="subDetailsViewR3">
          <div className="subDetailsSubscription">
            <span>Subscription Date:</span> 12/12/12
          </div>
        </div>
        <div className="subDetailsViewR4">
          <button className="goBackBtn" onClick={() => history.goBack()}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserSubscriptionDetails;
